<template>
  <div>
    <div class="row" v-if="user">

      <div class="col-lg-12">
          <!-- BEGIN VALIDATION STATES-->
          <div class="portlet light portlet-fit portlet-form bordered col-xs-12 p-0 ">
              <div class="portlet-title col-xs-12">
                  <div class="caption">
                      <i class=" icon-note font-green" v-if="$route.name=='users_edit'"></i>
                      <i class=" icon-plus font-green" v-else></i>
                      <span class="caption-subject font-green sbold uppercase" v-if="$route.name=='users_edit'">Modification de l'utilisateur</span>
                      <span class="caption-subject font-green sbold uppercase" v-else>Créer un nouvel utilisateur</span>
                  </div>
              </div>
              <div class="portlet-body col-xs-12">
                  <!-- BEGIN FORM-->
                  <form id="form_user_create" class="form-horizontal col-xs-12 absolute-parlsey-errors">
                      <div class="form-body col-xs-12">
                        <div class="col-xs-6">
                          <div class="form-group form-md-line-input">
                              <label class="col-md-3 control-label">Email
                                  <span class="required" aria-required="true">*</span>
                                  <!-- <div id="error_title" class="no-list"></div> -->
                              </label>
                              <div class="col-md-9">
                                  <input type="text" class="form-control" placeholder="" v-model="user.email" data-parsley-type="email" required>
                                  <div class="form-control-focus"> </div>
                              </div>
                          </div>

                          <div class="form-group form-md-line-input">
                              <label class="col-md-3 control-label">Username</label>
                              <div class="col-md-9">
                                <input type="text" class="form-control" placeholder="" v-model="user.username">
                                <div class="form-control-focus"> </div>
                              </div>
                          </div>

                          <div class="form-group form-md-line-input">
                              <label class="col-md-3 control-label">Prénom
                                  <span class="required" aria-required="true">*</span>
                              </label>
                              <div class="col-md-9">
                                  <input type="text" class="form-control" placeholder="" v-model="user.firstname" required>
                                  <div class="form-control-focus"> </div>
                              </div>
                          </div>

                          <div class="form-group form-md-line-input">
                              <label class="col-md-3 control-label">Nom
                                  <span class="required" aria-required="true">*</span>
                              </label>
                              <div class="col-md-9">
                                  <input type="text" class="form-control" placeholder="" v-model="user.lastname" required>
                                  <div class="form-control-focus"> </div>
                              </div>
                          </div>
                        </div>
                        <div class="col-xs-6">

                          <div class="form-group form-md-line-input">
                              <label class="col-md-3 control-label">Mot de passe
                                  <span class="required" aria-required="true" v-if="$route.name=='users_create'">*</span>
                              </label>
                              <div class="col-md-9">
                                  <input type="password" class="form-control" placeholder="" v-model="user.password" :required="$route.name=='users_create'">
                                  <div class="form-control-focus"> </div>
                              </div>
                          </div>

                          <div class="form-group form-md-line-input">
                              <label class="col-md-3 control-label">Role</label>
                              <div class="col-md-9">
                                  <select class="form-control" v-model="user.role">
                                    <option value="">Aucun</option>
                                    <option value="dev">Dev</option>
                                  </select>
                                  <div class="form-control-focus"> </div>
                              </div>
                          </div>

                        </div>

                      </div>
                      <div class="form-actions col-xs-12">
                          <div class="row">
                              <div class="text-center">
                                  <a v-if="$route.name=='users_edit'" v-on:click="updateUser()" class="btn green">Valider les modifications</a>
                                  <a v-else v-on:click="createUser()" class="btn green">Créer le nouveau utilisateur</a>
                                  <a v-on:click="$router.back()" class="btn default">Annuler</a>
                              </div>
                          </div>
                      </div>
                  </form>
                  <!-- END FORM-->
              </div>
          </div>
          <!-- END VALIDATION STATES-->
      </div>

    </div>
    <div class="row" v-else>
      <div class="col-md-12 page-404">
          <div class="number font-green"> 404 </div>
          <div class="details">
              <h3>Oops ! Utilisateur non trouvé.</h3>
              <p> Nous n'avons pas réussi à trouver cet utilisateur.
                  <br>
                  <router-link :to="{name:'users_list'}"> Retourner à la liste des utilisateurs </router-link> ou essayer de recharger la page.
              </p>
          </div>
      </div>
    </div>
  </div>
</template>

<script>

import users from '../../requests/users.js'

var user = {
  email:"",
  username:"",
  firstname:"",
  lastname:"",
  role:""
}

export default {
  name: 'users_create',
  data () {
    return{
      user:user
    }
  },
  mounted:function(){
    var parent = this;
    if(this.$route.params && this.$route.params.id){
      //Récupérer le produit à éditer.
      users.getById(this,this.$route.params.id,function(user,err){
        if(err){
          toastr.error("Impossible de récupérer l'utilisateur "+parent.$route.params.id+".","ERREUR");
          parent.user = null;
        }else{
          parent.user = user;
        }
      })
    }
  },
  methods:{
    createUser(){
      $('#form_user_create').parsley().validate()
      if($("#form_user_create").parsley().isValid()){
        var parent = this;
        users.create(this,this.user,function(user,err){
          if(user){
            toastr.success("L'utilisateur "+user.email+" a été ajouté.");
            parent.$router.push({name:'users_list'});
          }
          else{
            toastr.error(err,"ERREUR");
          }
        })
      }
    },
    updateUser(){
      $('#form_user_create').parsley().validate()
      if($("#form_user_create").parsley().isValid()){
        var parent = this;
        users.updateById(this,this.user.id,this.user,function(user,err){
          if(user){
            toastr.options.closeButton = true;
            toastr.success("L'utilisateur "+user.email+" a été mise à jour.");
            parent.$router.push({name:'users_list'});
          }
          else{
            toastr.error(err,"ERREUR");
          }
        })
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    // called when the route that renders this component is about to
    // be navigated away from.
    // has access to `this` component instance.

    // Réinit le user si on est sur la route users_edit et qu'on click sur users_create.
    this.user = user;
    next();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// create.vue?0e161dd9